import { H4 } from 'ui/theme';

import { useTranslations } from '../../hooks/useTranslations';

export const testIds = {
  header: 'mi-panel-content-header',
};

export const PanelHeader = () => {
  const { t } = useTranslations();

  return <H4 data-test={testIds.header}>{t('header.content')}</H4>;
};
